import { Button } from "../../../../components/buttons/button";
import { TextInput } from "../../../../components/inputs/textInput";
import { cleanHashes, formatDate } from "../../../../helperFunctions";
import { useAppSelector } from "../../../../redux/hooks";

export const ProfileInformation = ({
  fetchingMemberProfile,
  onProceed,
  isLoading,
}: {
  fetchingMemberProfile: boolean;
  onProceed: () => void;
  isLoading: boolean;
}) => {
  const { profile } = useAppSelector((state) => {
    return state.auth;
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <TextInput
        type="text"
        name={""}
        value={profile?.FirstName}
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName=""
        customIcon={undefined}
        hasTitle
        title="First Name"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <TextInput
        type="text"
        name={""}
        value={cleanHashes(profile?.MiddleName) || ""}
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName=""
        customIcon={undefined}
        hasTitle
        title="Middle Name"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <TextInput
        type="text"
        name={""}
        value={cleanHashes(profile?.LastName) || ""}
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName=""
        customIcon={undefined}
        hasTitle
        title="Last Name"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <TextInput
        type="text"
        name={""}
        value={formatDate(profile?.DateOfBirth) || ""}
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName=""
        customIcon={undefined}
        hasTitle
        title="Date of Birth"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <TextInput
        type="text"
        name={""}
        value={
          cleanHashes(
            `+${profile?.PhoneNumberCode?.replaceAll("#", "")}${
              profile?.PhoneNumber
            }`
          ) || ""
        }
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName="col-span-full"
        customIcon={undefined}
        hasTitle
        title="Phone Number"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <TextInput
        type="text"
        name={""}
        value={cleanHashes(profile?.Email) || ""}
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName="col-span-full"
        customIcon={undefined}
        hasTitle
        title="Email Address"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <TextInput
        type="text"
        name={""}
        value={cleanHashes(profile?.Address) || ""}
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName="col-span-full"
        customIcon={undefined}
        hasTitle
        title="Address"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <TextInput
        type="text"
        name={""}
        value={cleanHashes(profile?.Country) || ""}
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName=""
        customIcon={undefined}
        hasTitle
        title="Country"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <TextInput
        type="text"
        name={""}
        value={cleanHashes(profile?.State) || ""}
        placeholder="Not specified"
        onChange={() => {}}
        onBlur={() => {}}
        hasIcon={false}
        iconSvg={undefined}
        errors={undefined}
        inputClass=""
        className=""
        containerClassName=""
        customIcon={undefined}
        hasTitle
        title="State"
        disabled
        readOnly
        loading={fetchingMemberProfile}
      />

      <Button
        text="Next"
        onClick={() => {
          onProceed();
        }}
        type="button"
        className="mt-4 col-span-full"
        loading={isLoading}
        disabled={fetchingMemberProfile || isLoading}
        variation="primary"
      />
    </div>
  );
};
